// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"DataTable_dataTable__1FmVc","fileLink":"DataTable_fileLink__1VyAP"};